import { TagBrowser } from '@/features/tags'

export function TagsPage() {
  return (
    <div className="pb-20">
      <TagBrowser />
    </div>
  )
}
